import Vue from 'vue'
import config from 'client/config'
import socket from 'client/socket'
import find from "lodash/find";

const filter = require("lodash/filter")

export default function(store) {
  const state = {
    items: [],
    organisationId: null,
  }

  const actions = {
    'organisations.get': function() {
      leaveRooms()
      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/organisations').then(result => {
          store.commit('organisations.setItems', result.data)
          setRooms()
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisations.getById': function(ctx, organisationId) {
      leaveRooms()
      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/organisations/' + organisationId).then(result => {
          store.commit('organisations.setItems', [result.data])
          store.commit("organisations.setOrganisationId", organisationId)
          setRooms()
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisation.add': function(ctx, data) {
      return new Promise((resolve, reject) => {
        Vue.http.post(config.root + '/organisations/add', {data}).then(result => {
          store.commit('organisation.update', result.data)
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisation.update': function(ctx, organisation) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(config.root + '/organisations/' + organisation.id, organisation).then(result => {
          store.commit('organisation.update', result.data)
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisation.remove': function(state, orgId) {
      store.commit('organisation.remove', orgId)
      return new Promise((resolve, reject) => {
        Vue.http.delete(config.root + '/organisations/' + orgId).then(() => {
          resolve()
        }, err => reject(err))
      })
    }
  }

  const mutations = {
    "organisations.setOrganisationId": function(state, organisationId) {
      Vue.set(state, 'organisationId', organisationId)
    },
    "organisations.setItems": function(state, items) {
      Vue.set(state, 'items', items)
    },
    "organisation.remove": function(state, id) {
      state.items = filter(state.items, function(item) {
        return item.id !== id
      })
    },
    "organisation.update": function(state, user) {
      const index = state.items.findIndex(i => i.id === user.id)
      let orgs = state.items

      if (index >= 0) {
        orgs.splice(index, 1, user)
      }
      else {
        orgs.push(user)
      }

      Vue.set(state, 'items', orgs)
    }
  }

  const getters = {
    organisation: (state) =>  (orgId) => {
      return find(state.items, item => item.id === orgId)
    },
  }

  function setRooms() {
    if (state.organisationId) {
      socket.emit('join', 'organisation:' + state.organisationId)
    }
    else if (state.items.length) {
      socket.emit('join', 'organisations')
    }
  }

  function leaveRooms() {
    socket.emit('leave', 'organisations')
    if (state.organisationId) {
      socket.emit('leave', 'organisation:' + state.organisationId)
      store.commit("organisations.setOrganisationId", undefined)
    }
  }

  function listener() {
    socket.on('connect', function () {
      setRooms()
    })
    socket.on('organisation.update', function(result) {
      if (result.type === 'update') {
        store.commit('organisation.update', result.data)
        return
      }
      if (result.type === 'create') {
        store.commit('organisation.update', result.data)
      }
    })
    socket.on('organisation.delete', result => {
      store.commit('organisation.remove', result.data)
    })
    socket.emit('join', 'organisation.delete')
  }

  store.registerModule('organisations', {
    state,
    mutations,
    actions,
    getters,
  })

  listener()
}
